export default "__VITE_ASSET__CuwBPSUH__"